import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CustomIconsMap, registerMaterialIconsProviderFabric } from '@core';
import { DEFAULT_LOCALE } from '@di-tokens';
import { MSAL_BOOTSTRAP_COMPONENTS, MSAL_MODULE, MSAL_PROVIDERS } from '@msal';
import { routes } from './routes';
import { AppComponent } from './app.component';
import { ShellComponent } from './shell/shell.component';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

export const CUSTOM_ICONS = [
  'ico_cart',
  'ico_alert',
  'ico_heart',
  'ico_account',
  'ico_credit_card',
  'ico_caret_left',
  'ico_caret_right',
  'ico_minus',
  'ico_caret_down',
  'ico_plus',
  'ico_arrow_right',
  'ico_arrow_left',
  'ico_caret',
  'ico_category',
  'ico_checkmark_filled',
  'ico_close',
  'ico_search',
  'ico_tag',
  'ico_soft',
  'ico_heart_filled',
  'ico_info',
  'ico_info_current_color',
  'ico_checkmark',
  'ico_trash',
  'ico_cart_empty',
  'ico_edit',
  'ico_accordion_caret_right',
  'ico_visa_card',
  'ico_pause',
] as const;

export const CUSTOM_ICONS_MAP: CustomIconsMap<(typeof CUSTOM_ICONS)[number]> = CUSTOM_ICONS.reduce(
  (result, iconName) => {
    result[iconName] = `/assets/images/icon/${iconName}.svg`;
    return result;
  },
  {} as CustomIconsMap<(typeof CUSTOM_ICONS)[number]>,
);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent, ...MSAL_BOOTSTRAP_COMPONENTS],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
    RouterModule,
    ShellComponent,
    MSAL_MODULE,
  ],
  providers: [
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 6000, verticalPosition: 'top' } },
    {
      provide: DEFAULT_LOCALE,
      useValue: 'en-US',
    },
    registerMaterialIconsProviderFabric(CUSTOM_ICONS_MAP),
    ...MSAL_PROVIDERS,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
}
